import { FC, useState } from "react";
import { Box, Typography } from "@mui/material";
import { books } from "@/assets/books";
import { Outlet, useLocation } from "react-router-dom";
import { RequireAuth } from "@/components/RequireAuth";
import DeactivateAccountModal from "./component/DeactivateAccountModal";
import ForgotPassword from "@/components/UI/modal/Wallet/ForgotPassword";
import MenuItemCard from "./component/MenuItemCard";
// import { useAppSelector } from "@/hooks/useAppSelector";

// type ContextType = { menu: any | null };
const Settings: FC = () => {
  const location = useLocation();
  const [isDeactivateOpen, setIsDeactivateOpen] = useState(false);
  const [walletForgotPasswordModalOpen, setWalletForgotPasswordModalOpen] = useState(false);

  const [menuItems] = useState([
    {
      title: "Your account",
      link: books.yourAccount,
    },
    {
      title: "Notifications",
      link: books.notifications,
    },
    {
      title: "Premium Subscription",
      link: books.premium,
    },
    {
      title: "Wallet",
      link: books.walletSettings,
    },
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
      }}
    >
      <Box
        sx={{
          flex: "0 0 45.8%",
          borderRight: "1px solid #E0E0E0",
        }}
      >
        <DeactivateAccountModal
          open={isDeactivateOpen}
          onClose={() => setIsDeactivateOpen(false)}
          onConfirm={() => {
            setIsDeactivateOpen(false);
          }}
        />
        {walletForgotPasswordModalOpen && (
          <ForgotPassword onClose={() => setWalletForgotPasswordModalOpen(false)} />
        )}

        <Box
          sx={{
            height: "54px",
            padding: "15px 0 15px 16px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontStyle: "Semi Bold",
              fontSize: "18px",
              lineHeight: "24px",
              letterSpacing: "0px",
            }}
          >
            Settings
          </Typography>
        </Box>
        <Box bgcolor="white">
          <RequireAuth>
            {menuItems.map((item, index) => {
              const isActive = !!item.link && location.pathname.includes(item.link);
              return <MenuItemCard key={index} item={item} active={isActive} />;
            })}
          </RequireAuth>
        </Box>
      </Box>

      <Box sx={{ flex: "0 0 54.2%", maxWidth: "544px" }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Settings;
